
export const TAG_GENERATION_ACL_OBJECTS = [
    'TagGeneration',
];
